let currentMonaco = null;

/**
 * xyclient的monaco是一个amd模块并非同步加载，工程中的对monaco的同步调用都应该通过这个函数的回调函数来执行
 *
 * @param {(monaco: typeof import('monaco-editor') | null) => any} callback
 * @example
 * import monacoProvider from './monacoProvider.js'
 * monacoProvider((monaco) => {
 *    this.diffEditor =  monaco.editor.createDiffEditor(this.$refs.diffContainer);
 * })
 */
export function getMonacoWithCallback(callback) {
  var _window$monaco;
  if (!currentMonaco && typeof ((_window$monaco = window.monaco) === null || _window$monaco === void 0 || (_window$monaco = _window$monaco.editor) === null || _window$monaco === void 0 ? void 0 : _window$monaco.createModel) === 'function') setMonaco(window.monaco);
  if (currentMonaco) return callback(currentMonaco);
  try {
    window.require(['vs/editor/editor.main'], m => {
      setMonaco(m);
      callback(m);
    }, () => callback(currentMonaco) // onError
    );
  } catch (e) {
    callback(null);
  }
}
export default getMonacoWithCallback;

/**
 * 获取 monaco 模块。注意，如果不存在，会拿到 null
 */
export const getMonaco = () => new Promise(getMonacoWithCallback);

/**
 * 指定 monaco 模块。这个会影响后续全部 getMonaco 和 getMonacoWithCallback 的调用
 */
export const setMonaco = monaco => {
  currentMonaco = monaco;
  console.log('[UICore] monaco is ready!');
};